import { useMutation } from 'react-query';

import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useHandleErrors } from 'coreOld/hooks';
import { useNotification } from 'coreOld/hooks/useNotification';
import { filesService } from 'coreOld/services';

export const useFilesActions = () => ({
  ...useFileUpload(),
});

const useFileUpload = () => {
  const { showNotification, clearNotification } = useNotification();

  const { errors } = useHandleErrors('', 'Reading File...', NotificationPosition.TOP);

  const { mutateAsync } = useMutation(filesService.uploadFile, {
    ...errors,
    onSuccess: (obj) => {
      const { data } = obj;
      const isError = Object.keys(data[0]).includes('error');

      if (isError) {
        showNotification({
          message: data[0]?.error,
          type: ApiStatuses.ERROR,
          position: NotificationPosition.TOP,
        });

        return;
      }

      clearNotification();
    },
  });

  const fileUpload = (data, queryParams) => mutateAsync({ data, queryParams });

  return { fileUpload };
};
